const Stop = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.5 8A2.5 2.5 0 0 1 8 5.5h8A2.5 2.5 0 0 1 18.5 8v8a2.5 2.5 0 0 1-2.5 2.5H8A2.5 2.5 0 0 1 5.5 16zM8 6.5A1.5 1.5 0 0 0 6.5 8v8A1.5 1.5 0 0 0 8 17.5h8a1.5 1.5 0 0 0 1.5-1.5V8A1.5 1.5 0 0 0 16 6.5z"
      clipRule="evenodd"
    />
  </>
)
export default Stop
